<template>
  <div class="TransactionHistory">
    <div class="box-card" v-loading="is_transaction_loading">
      <div
        class="label-md-bold-black font-weight-600 flex bottom-margin-20 title"
        style="color: #2d2e8d; align-items: center;"
      >
        <img
          src="../assets/images/myAccount/Transaction history - Icon.svg"
          width="18px"
          alt=""
        />
        <span class="left-margin-5">
          Transaction History
        </span>
      </div>
      <div class="board-table-outer" v-if="transactionHistoryList.length">
        
        <table class="outer-board-table board-table" v-loading="is_payment_history_loading">
          <thead>
            <tr class="main-head">
              <th class="text-left">Invoice Number</th>
              <th>Plan</th>
              <th>Amount</th>
              <th>Billing Date</th>
              <th>Status</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(transaction, index) in transactionHistoryList">
              <tr>
                <td style="text-align: left;">
                  {{ transaction.invoice_no ? transaction.invoice_no : "-" }}
                </td>
                <td>
                  {{ transaction.plan_name ? transaction.plan_name : "-" }}
                </td>
                <td>₹ {{ transaction.transaction_amount }}</td>
                <td>
                  {{
                    moment(transaction.transaction_datetime).format(
                      "DD MMM YYYY"
                    )
                  }}
                </td>
                <td>{{ transaction.transaction_status }}</td>
                <td>
                  <div style="float:left">
                    <span
                      class="download-btn"
                      @click="downloadPdf(transaction.invoice_pdf)"
                    >
                      <i
                        class="el-icon-bottom font-weight-600"
                        style="font-size: 13px;"
                      ></i>
                      Download
                    </span>
                    <span v-if="transaction.plan_name !== 'Publisher'">
                    <i
                      v-if="selectedAdvisoryIndex == index"
                      class="el-icon-arrow-down download-btn left-margin-10"
                      style="font-size: 15px;"
                      @click="showAdvisoryByIndex(index)"
                    ></i>
                    <i
                      v-else
                      class="el-icon-arrow-up download-btn left-margin-10"
                      style="font-size: 15px;"
                      @click="showAdvisoryByIndex(index)"
                    ></i>
                  </span>
                  </div>
                </td>
              </tr>
              <tr v-if="selectedAdvisoryIndex == index" ref="advisoryRow">
                <td colspan="6" class="sub-section">
                  <div class="sub-sec-head">Advisory Services</div>
                  <div class="table-padding">
                    <div class="text-left bottom-margin-15 font-weight-600">
                      from:
                    </div>
                    <div class="inner-table">
                      <table class="board-table board-table-inner">
                        <thead>
                          <tr>
                            <th class="text-left">Name</th>
                            <th>SEBI No.</th>
                            <th>Email ID</th>
                            <th>Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="advisor in transaction.advisory"
                            :key="advisor.expert_sebi_no"
                          >
                            <td style="text-align: left;">
                              {{
                                advisor.expert_name ? advisor.expert_name : "-"
                              }}
                            </td>
                            <td>
                              {{
                                advisor.expert_sebi_no
                                  ? advisor.expert_sebi_no
                                  : "-"
                              }}
                            </td>
                            <td>
                              {{
                                advisor.expert_email_id
                                  ? advisor.expert_email_id
                                  : "-"
                              }}
                            </td>
                            <td>
                              <i
                                class="el-icon-bottom download-btn"
                                style="font-size: 13px;"
                                @click="downloadPdf(advisor.expert_invoice_pdf)"
                              ></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <NoDataFound v-else></NoDataFound>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from "../networkConfig";
import NoDataFound from "../components/NoDataFound.vue";
import moment from "moment";

export default {
  name: "TransactionHistory",
  components: {
    NoDataFound,
  },
  mixins: [],
  data() {
    return {
      serverHostName: serverHostName,
      is_transaction_loading: false,
      toggle_more_info: false,
      moment: moment,
      websiteUserType: localStorage.getItem("websiteUserType")
        ? JSON.parse(localStorage.getItem("websiteUserType"))
        : {},

      transactionHistoryList: [],
      selectedAdvisoryIndex: null,
      is_payment_history_loading: false,
    };
  },

  computed: {
    //   TransactionHistoryList() {
    //     // return this.$store.state.subscribed_features_list;
    //   },
  },

  mounted() {
    this.getPaymentHistory();
  },

  methods: {
    downloadPdf(path) {
      window.open(`${this.serverHostName + "/" + path}`, "_blank");
    },
    showAdvisoryByIndex(index) {
      if (this.selectedAdvisoryIndex == index) {
        this.selectedAdvisoryIndex = null;
      } else {
        this.selectedAdvisoryIndex = index;
        this.scrollIntoView(index);
      }
    },
    scrollIntoView(index) {
      this.$nextTick(() => {
        const row = this.$refs.advisoryRow[index];
        row.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    },
    getPaymentHistory() {
      this.is_payment_history_loading = true; //enabled loader
      serverAddr
        .post("/stockants_pro/get-transaction-history/")
        .then((response) => {
          if (response.data.status && response.data.data.length) {
            this.transactionHistoryList = response.data.data;

            this.transactionHistoryList.forEach((element) => {
              element.isAdvisoryShow = false;
            });
          }
          this.is_payment_history_loading = false; //disabled loader

          this.no_download_reco_category_selected_error = false; //disabled error msg
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_payment_history_loading = false; //disabled loader
          }.bind(this)
        );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.TransactionHistory {
  /* CSS styles */
  .expandable-row {
    cursor: pointer;
  }
  .details {
    display: none;
  }
  .details.show {
    display: table-row;
  }
  .box-card {
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
    -webkit-transition: 0.3s;
    transition: 0.3s;

    .title {
      padding: 20px 20px 10px;
      border-bottom: 5px solid;
    }
  }
}
</style>
<style lang="scss">
.TransactionHistory {
  .table-padding {
    padding: 20px;
  }
  .inner-table {
    border-radius: 8px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    overflow: hidden;
    color: #303133;

    .board-table-inner {
      td {
        border-bottom: 1px solid #e9e9e9;
      }
    }
  }
  .board-table-outer {
    .sub-section {
      padding: 0 !important;
    }
    .sub-sec-head {
      width: 100%;
      text-align: left;
      background-color: #2d2e8d;
      padding: 10px;
      color: #ffff;
      margin: 10px 0 0;
      font-weight: 600;
    }
    .download-btn {
      padding: 5px 10px;
      font-size: 12px;
    }
  }
  .board-table {
    overflow-x: auto;
    border-spacing: 0;
    border-collapse: collapse;
    width: 100%;

    .main-head th {
      color: #000;
    }

    .border-right-gray {
      border-right: 1px solid #e9e9e9;
    }
    .border-bottom-gray {
      border-bottom: 1px solid #e9e9e9;
    }
    .bottom-spacing-table-heading {
      padding: 0px 8px 8px 8px;
    }
    thead {
      tr {
        th {
          color: #a5a6a8;
          font-size: 0.9rem;
          font-weight: 600;
          padding: 10px 20px;
          white-space: nowrap;
        }
      }

      tr:nth-child(1) {
        border-bottom: 1px solid #e9e9e9;
      }
    }
    tbody {
      tr {
        cursor: pointer;
        td {
          font-size: 0.8rem;
          font-weight: 500;
          text-align: center;
          padding: 10px 20px;
          vertical-align: unset;
        }
      }
      // tr:hover {
      //   background-color: #eff5fe;
      // }
    }
  }

  @media screen and (max-width: 700px) {
    .board-table {
      display: block;
      overflow-x: auto;
    }
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #2d2e8d;
    border-color: #2d2e8d;
  }
  .NoDataFound {
    padding: 0;
  }
}
</style>
